import GQLClient from '@sbvr/lbe-api/GQLClient';

let gql: GQLClient;

export function initGQL (initGQL: GQLClient): void {
  gql = initGQL;
}

export function useGQL (): GQLClient {
  return gql;
}
